<template>
    <dash
        icon="fa fa-refresh"
        titulo="REABERTURAS DE ENTREGAS"
        subTitulo="SGF GERENTE"
        @click.native="
            $router.push({ name: 'Gerentes_SolicitacoesReaberturas' })
        "
        :qtd="qtd"
        :mostrarQtd="$temAcessoView('CRED-GER-ENTR-02') ? true : false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
